const copyBtns = document.querySelectorAll('.copy-btn');

copyBtns?.forEach(btn => {
  btn.addEventListener('click', event => {
    const copyBox = event.target.closest('.copy-box');
    if (!copyBox) return;

    const copyElem = copyBox.querySelector('.copy-elem span');
    if (!copyElem) return;

    const clipboardElem = copyBox.dataset.clipboard;
    const textToCopied = copyBox.dataset.copied;

    const width = copyElem.offsetWidth;
    copyElem.style.minWidth = `${width}px`;

    navigator.clipboard
      .writeText(clipboardElem)
      .then(() => {
        if (!copyBox.timer) copyBox.timer = null;

        copyBox.classList.add('is-copy');

        if (textToCopied) copyElem.textContent = textToCopied;

        if (copyBox.timer) clearTimeout(copyBox.timer);

        copyBox.timer = setTimeout(() => {
          if (textToCopied) copyElem.textContent = clipboardElem;
          copyBox.classList.remove('is-copy');

          copyElem.style.minWidth = '';

          copyBox.timer = null;
        }, 1000);
      })
      .catch(err => {
        console.error('Помилка при копіюванні: ', err);
        copyElem.style.minWidth = '';
      });
  });
});

// <div
//   class="copy-box"
//   data-copied="Copied to the clipboard"
//   data-clipboard="Clipboard"
// >
//   <button type="button" class="copy-btn" aria-label="Copy button">
//     X
//   </button>
//   <a href="#" class="copy-elem">
//     Clipboard
//   </a>
// </div>
